// extracted by mini-css-extract-plugin
export default {"container":"PageLoading_container__rwEEy","placeholder":"PageLoading_placeholder__Gu8O1"};